import { render, staticRenderFns } from "./POmodal.vue?vue&type=template&id=f259647a"
import script from "./POmodal.vue?vue&type=script&lang=js"
export * from "./POmodal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports